import React from 'react';

import { makeVar } from '@apollo/client';
import { Menubar } from '@base-ui/react/menubar';
import { SelectButton } from 'src/components';
import type { DeclarativeMenuConfig } from 'src/components/declarative-menu';
import { DeclarativeMenu } from 'src/components/declarative-menu';
import { PLANNED_MENU_ITEMS_FLAG } from 'src/helpers';
import { useEditorLoading } from 'src/layout-engine/hooks';
import { makeStyles } from 'tss-react/mui';

import { useEditMenu } from './menus/use-edit-menu';
import { useFileMenu } from './menus/use-file-menu';
import { useFormatMenu } from './menus/use-format-menu';
import { useHelpMenu } from './menus/use-help-menu';
import { useToolsMenu } from './menus/use-tools-menu';
import { useViewMenu } from './menus/use-view-menu';

export const tablePropertiesDialogOpenVar = makeVar<boolean>(false);
export const crossReferenceDialogOpenVar = makeVar<boolean>(false);

const useStyles = makeStyles()(theme => ({
  menubar: {
    display: 'flex',
    gap: theme.spacing(0.5),
  },
}));

export const ToolbarMenus = React.memo(function ToolbarMenus() {
  const { classes } = useStyles();
  const editorLoading = useEditorLoading();

  const fileMenu = useFileMenu();
  const editMenu = useEditMenu();
  const viewMenu = useViewMenu();
  const formatMenu = useFormatMenu();
  const toolsMenu = useToolsMenu();
  const helpMenu = useHelpMenu();

  const menus: [label: string, config: DeclarativeMenuConfig | null][] = [
    ['File', fileMenu],
    ['Edit', editMenu],
    ['View', viewMenu],
    ['Format', formatMenu],
    ['Tools', PLANNED_MENU_ITEMS_FLAG ? toolsMenu : null],
    ['Help', helpMenu],
  ];

  return (
    <Menubar className={classes.menubar}>
      {menus.map(
        ([label, config]) =>
          config && (
            <DeclarativeMenu key={label} config={config} disabled={editorLoading}>
              {(renderProps, state) => (
                <SelectButton
                  disabled={state.disabled}
                  selected={state.open}
                  style={{ fontWeight: 'normal' }}
                  {...renderProps}
                >
                  {label}
                </SelectButton>
              )}
            </DeclarativeMenu>
          )
      )}
    </Menubar>
  );
});
